import React from "react";
import BreadCrumbs from "../../common/BreadCrumbs";
import { useParams } from "react-router-dom";
import { INDUSTRIES } from "../../constants/IndustryConstant";

const IndustryDetails = () => {
  const { industryId } = useParams<{ industryId: string }>();
  const currentIndustry =
    INDUSTRIES.filter((item) => item.id === industryId)?.[0] || {};

  const overview = currentIndustry.data.find(
    (section) => section.title === "Overview"
  );
  const solution = currentIndustry.data.find(
    (section) => section.title === "Solution"
  );
  const process = currentIndustry.data.find(
    (section) => section.title === "Process"
  );
  const additional = currentIndustry.data.find(
    (section) => section.title === "Additional Insights"
  );

  return (
    <>
      <BreadCrumbs title="Industries" description={currentIndustry.tag} />

      <div className="case-study-details sec-mar">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="case-study-title">
                <h2> {currentIndustry.title} </h2>
              </div>
              {/* Banner Image */}
              <div className="case-big-img magnetic-item">
                <img
                  className="img-fluid"
                  src={currentIndustry.bannerImage}
                  alt={currentIndustry.title}
                />
              </div>
              {/* First Description */}
              <div className="case-content mb-60">
                <p> {currentIndustry.data[0].description} </p>
              </div>
              {/* Overview Section */}
              {overview && (
                <div className="row g-lg-4 gy-5 mb-120">
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="case-content">
                      <h2> {overview.title} </h2>
                      <p> {overview.description} </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="case-img magnetic-item">
                      <img
                        className="img-fluid"
                        src={overview.image}
                        alt={overview.title}
                      />
                    </div>
                  </div>
                </div>
              )}
              {/* Solution Section */}
              {solution && (
                <div className="row g-lg-4 gy-5 mb-120">
                  <div className="col-lg-6">
                    <div className="case-img magnetic-item">
                      <img
                        className="img-fluid"
                        src={solution.image}
                        alt={solution.title}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="case-content">
                      <h2> {solution.title} </h2>
                      <p> {solution.description} </p>
                    </div>
                  </div>
                </div>
              )}
              {/* Process Section */}
              {process && process.steps && (
                <div className="row mb-120">
                  <div className="col-lg-12">
                    <div className="case-content mb-60">
                      <h2> {process.title} </h2>
                      <p> {process.description} </p>
                    </div>
                    <div className="row g-4 justify-content-center">
                      {process.steps.map((steps, index) => (
                        <div key={index} className="col-xl-3 col-sm-6">
                          <div className="single-process magnetic-item">
                            <div className="icon">
                              <img
                                src={steps.icon}
                                alt={steps.title}
                                style={{
                                  opacity: steps.title === "Testing" ? 0.1 : 1,
                                }}
                              />
                            </div>
                            <span> {steps.step} </span>
                            <h3> {steps.title} </h3>
                            <p>
                              {steps.description.length > 120
                                ? steps.description.substring(0, 120) + "..."
                                : steps.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {/* Additional Images Section */}
              {additional && (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="case-content mb-60">
                      <h2> {additional.title} </h2>
                      <p>{additional.description}</p>
                    </div>
                    <div className="row g-4 justify-content-center">
                      {additional.additionalImages?.map(
                        (img, index) => (
                          <div className="col-md-6">
                            <div className="case-img magnetic-item">
                              <img
                                className="img-fluid"
                                src={img}
                                alt={`Additional ${index + 1}`}
                              />
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndustryDetails;
